import {CrudManager} from "@/scripts/ProfiControlRequests/CrudManager";
import {PasswordChange} from "@/model/PasswordChange";
import {ResponseState} from "@/Enums";

const changePasswordRequest = async (url: string, model: PasswordChange, token: string) => {
    let state
    try {
        await CrudManager.Post<string>(url, model, token)
        state = ResponseState.success;
    }
    catch (_){
        state = ResponseState.error;
    }

    return state;
}


export {
    changePasswordRequest
}
